var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticStyle: { "font-size": "xx-small" } }, [
        _vm._v("Red colour: current value outside operating thresholds.")
      ]),
      _c("div", { staticStyle: { "font-size": "xx-small" } }, [
        _vm._v("Badge: number of losses uncategorised during last 24 hours.")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }